<template>
  <v-menu :position-x="position.x" :position-y="position.y" v-model="menu" :close-on-content-click="false" :nudge-width="300" offset-x>
    <v-form ref="form" style="width: 100%;">
      <v-card>
        <v-card-title class="title py-1">
          {{ type }} recipient
          <v-spacer />
          <v-btn class="ma-0" icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-text-field v-model="formObject.email" label="Email*" :rules="[rules.required, rules.email]" :error-messages="errorMessages.email" />
          <v-text-field v-model="formObject.name" label="Name" />
        </v-card-text>
        <v-card-actions class="">
          <v-spacer />
          <v-btn color="success" outline @click="submit()">{{$t('Button.Save')}}</v-btn>
          <v-btn outline color="secondary" @click="close()">{{$t('Button.Cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-menu>
</template>

<script>
  const TYPES = {
    create: 'Add',
    update: 'Edit',
  }

  const emailExists = 'Email already used'

  export default {
    props: {
      configuration: Object,
      position: {
        type: Object,
        default: () => ({
          x: 0,
          y: 0,
        }),
      },
    },
    data: () => ({
      menu: false,
      formObject: {},
      initialObject: {
        email: null,
        name: null,
        reportIds: [],
      },
      errorMessages: {
        email: [],
      },
      type: TYPES.create,
      initialRecipient: null,
    }),
    computed: {
      rules() {
        return {
          required: (v) => !!v || 'Required',
          email: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Please enter a valid email',
        }
      },
    },
    methods: {
      emailIndex(v) {
        return this.configuration.recipients.findIndex(r => r.email == v)
      },
      submit() {
        if (!this.$refs.form.validate()) return

        if (this.type == TYPES.create) {
          this.create()
        } else if (this.type == TYPES.update) {
          this.update()
        } else {
          throw 'Unsupported type'
        }
      },
      update() {
        let recipient = JSON.parse(JSON.stringify(this.formObject))
        let emailIndex = this.emailIndex(recipient.email)
        let recipientIndex = this.emailIndex(this.initialRecipient.email)

        if (emailIndex != -1 && emailIndex != recipientIndex) {
          this.errorMessages.email = [emailExists]
          return
        }

        this.errorMessages.email = []
        this.configuration.recipients.splice(recipientIndex, 1, recipient)
        this.close()
      },
      create() {
        let recipient = JSON.parse(JSON.stringify(this.formObject))
        let emailIndex = this.emailIndex(recipient.email)

        if (emailIndex != -1) {
          this.errorMessages.email = [emailExists]
          return
        }

        this.errorMessages.email = []
        this.configuration.recipients.push(recipient)
        this.close()
      },
      show(recipient) {
        this.type = TYPES.create
        this.menu = true

        this.initialRecipient = recipient
        if (recipient) {
          this.type = TYPES.update

          this.formObject = {
            ...this.formObject,
            ...recipient,
          }
        } else {
          this.reassign()
        }
      },
      close() {
        this.reassign()
        this.menu = false
      },
      reassign() {
        this.formObject = JSON.parse(JSON.stringify(this.initialObject))
        this.$refs.form.reset()
      },
    },
    mounted() {
      this.reassign()
    },
  }
</script>